import { render, staticRenderFns } from "./TagDiscount.vue?vue&type=template&id=481339d2&scoped=true&"
import script from "./TagDiscount.vue?vue&type=script&lang=js&"
export * from "./TagDiscount.vue?vue&type=script&lang=js&"
import style0 from "./TagDiscount.vue?vue&type=style&index=0&id=481339d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481339d2",
  null
  
)

export default component.exports